/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina } from './VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina';
import {
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSON,
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped,
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON,
} from './VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina';
import type { VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit } from './VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit';
import {
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSON,
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped,
  VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitToJSON,
} from './VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit';

/**
 * @type VoiceAgentInferencerPolymorphic
 *
 * @export
 */
export type VoiceAgentInferencerPolymorphic =
  | ({ protocol: 'CELINA' } & VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelina)
  | ({ protocol: 'LIVEKIT' } & VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKit);

export function VoiceAgentInferencerPolymorphicFromJSON(json: any): VoiceAgentInferencerPolymorphic {
  return VoiceAgentInferencerPolymorphicFromJSONTyped(json, false);
}

export function VoiceAgentInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): VoiceAgentInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign({}, VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaFromJSONTyped(json, true), {
        protocol: 'CELINA',
      } as const);
    case 'LIVEKIT':
      return Object.assign({}, VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitFromJSONTyped(json, true), {
        protocol: 'LIVEKIT',
      } as const);
    default:
      throw new Error(`No variant of VoiceAgentInferencerPolymorphic exists with 'protocol=${json['protocol']}'`);
  }
}

export function VoiceAgentInferencerPolymorphicToJSON(value?: VoiceAgentInferencerPolymorphic | null): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return VoiceAgentInferencerPolymorphicVoiceAgentInferencerCelinaToJSON(value);
    case 'LIVEKIT':
      return VoiceAgentInferencerPolymorphicVoiceAgentInferencerLiveKitToJSON(value);
    default:
      throw new Error(`No variant of VoiceAgentInferencerPolymorphic exists with 'protocol=${value['protocol']}'`);
  }
}
